// istanbul ignore file
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    flex: 1 1 0;
    justify-content: center;
`;

export const RecentDealListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    flex: 1 1 0;
    overflow: auto;

    .deal-card {
        position: relative;
        border: 1px solid #b2b2b2;
        border-bottom: none;
    }

    .deal-card:first-child {
        border-radius: 4px 4px 0 0;
    }

    .deal-card:hover {
        cursor: pointer;
    }

    .active {
        background-color: #ebf6ff;
    }
    .active::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background-color: #003468;
    }
`;
